import {
  METRIC_TABLE_PART,
  METRIC_TABLE_PART_TYPE,
  metricTableV1Schema,
  type MetricTableV1,
} from "./metric-table.js";

export * from "./metric-table.js";

/** Every part the chat can render, by its `data-<name>` name. */
export const UI_PART_SCHEMAS = {
  [METRIC_TABLE_PART]: metricTableV1Schema,
} as const;

export type UiPartName = keyof typeof UI_PART_SCHEMAS;

export type ParsedUiPart = { name: typeof METRIC_TABLE_PART; data: MetricTableV1 };

export function isUiPartType(type: string): boolean {
  return type.startsWith("data-") && type.slice("data-".length) in UI_PART_SCHEMAS;
}

/**
 * Parses a `data-<name>` part the renderer received. Unknown names and
 * payloads that do not match their schema give null: the renderer shows
 * nothing rather than something half right.
 */
export function parseUiPart(type: string, data: unknown): ParsedUiPart | null {
  if (type !== METRIC_TABLE_PART_TYPE) return null;
  const parsed = metricTableV1Schema.safeParse(data);
  return parsed.success ? { name: METRIC_TABLE_PART, data: parsed.data } : null;
}
